import axios from 'axios';
import {baseExpApi, isAks} from './properties/UrlsAndEnvProperties';
import { UserManager } from '@forge/sso-client';

const defaultOptions = {
    baseURL: baseExpApi(),
    headers: {
      'Content-Type': 'application/json',
    },
  };
  
  async function  getBearerToken(): Promise<string> {
    const userManager =UserManager.getInstance();
    const user = (await userManager.getUser());
    if((user)?.expired){
      await userManager.signinSilent().catch(() => userManager.signinRedirect());
    }
    try {
        return `Bearer ${ isAks() ? sessionStorage.getItem("token") : (user)?.access_token}`;
    } catch (error) {
        console.log(`Unable to get bearer token: ${error}`);
        console.error(error);
    }
    return '';
  }
const axiosInstance = axios.create(defaultOptions);

axiosInstance.interceptors.request.use(async (request:any) => {

  request.headers['Authorization'] =await getBearerToken();
  
 
    return request;
});

export default axiosInstance;